import { render } from "./BasicProjectDataTab.vue?vue&type=template&id=fe8a5438&scoped=true"
import script from "./BasicProjectDataTab.vue?vue&type=script&lang=js"
export * from "./BasicProjectDataTab.vue?vue&type=script&lang=js"

import "./BasicProjectDataTab.vue?vue&type=style&index=0&id=fe8a5438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8a5438"]])

export default __exports__